export default "__VITE_ASSET__BSGeLLGh__"